import React from "react";
import ColumnTitle from './ColumnTitle.jsx';

const TableHeader = (props) => {

    const { orderColumn } = props;
    let icon = false;

    return (
        <thead>
            <tr>
                <th>
                    <ColumnTitle title="NOMBRE"
                        columnName="NOMBRE"
                        icon={icon} 
                        orderColumn={orderColumn}
                        data={props.data} />
                </th>
                <th>
                    <ColumnTitle title="REGISTROS ACTIVOS"
                        columnName="REGISTROS ACTIVOS"
                        icon={icon}
                        orderColumn={orderColumn}
                        data={props.data} />
                </th>
                <th>
                    <ColumnTitle title="EQUIVALENCIAS"
                        columnName="equivalencias"
                        icon={icon}
                        orderColumn={orderColumn}
                        data={props.data} />
                </th>
                <th>
                    <ColumnTitle title="PRODUCTOS"
                        columnName="productos"
                        icon={icon}
                        orderColumn={orderColumn}
                        data={props.data} />
                </th>
            </tr>
        </thead>
    );
};

export default TableHeader